/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".dialog-content[_ngcontent-%COMP%]{min-height:300px}.app-dialog-body-text[_ngcontent-%COMP%]{padding-top:10px;padding-left:20px}"];
export { styles as styles };
